import React, { useCallback, useEffect, useState } from "react";
import api from "../../services/api";

const KoraxPendingClaims = ({
  companyId,
  socket,
  onClaimed
}) => {
  const [pending, setPending] = useState([]);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    if (Number(companyId) !== 75) return;

    try {
      const { data } = await api.get("/tickets", {
        params: {
          status: "pending",
          scope: "sector",
          pageNumber: "1",
          showAll: "false"
        }
      });

      const eligible = (data.tickets || []).filter(
        ticket =>
          ticket.status === "pending" &&
          ticket.userId == null &&
          ticket.aiActive === false &&
          ticket.queueId != null
      );

      setPending(eligible);
      setError("");
    } catch (err) {
      setError("Não foi possível atualizar os atendimentos.");
    }
  }, [companyId]);

  useEffect(() => {
    if (Number(companyId) !== 75) return undefined;

    load();

    const ticketEvent = `company-${companyId}-ticket`;
    const handoffEvent = `company-${companyId}-handRaise`;

    if (socket) {
      socket.on(ticketEvent, load);
      socket.on(handoffEvent, load);
    }

    const interval = setInterval(load, 20000);

    return () => {
      clearInterval(interval);
      if (socket) {
        socket.off(ticketEvent, load);
        socket.off(handoffEvent, load);
      }
    };
  }, [companyId, socket, load]);

  const accept = async ticket => {
    if (busyId !== null) return;

    setBusyId(ticket.id);
    setError("");

    try {
      await api.post(`/tickets/${ticket.id}/claim`);

      setPending(previous =>
        previous.filter(item => item.id !== ticket.id)
      );

      await load();

      if (onClaimed) onClaimed();
    } catch (err) {
      const code = err.response?.data?.code;

      setError(
        code === "TICKET_ALREADY_CLAIMED"
          ? "Esse atendimento já foi assumido por outra pessoa."
          : "Não foi possível assumir o atendimento."
      );

      await load();
    } finally {
      setBusyId(null);
    }
  };

  if (Number(companyId) !== 75) return null;

  if (!pending.length && !error) return null;

  return (
    <section
      style={{
        margin: "12px",
        padding: "12px",
        border: "1px solid #DBEAFE",
        borderRadius: 12,
        backgroundColor: "#F8FAFF"
      }}
    >
      <div
        style={{
          fontWeight: 700,
          fontSize: 13,
          marginBottom: 10,
          color: "#010B36"
        }}
      >
        Cliente aguardando atendimento
        {pending.length > 0 ? ` (${pending.length})` : ""}
      </div>

      {error ? (
        <div
          role="alert"
          style={{
            fontSize: 12,
            color: "#B45309",
            marginBottom: 8
          }}
        >
          {error}
        </div>
      ) : null}

      {pending.map(ticket => (
        <div
          key={ticket.id}
          style={{
            background: "#FFFFFF",
            border: "1px solid #E2E8F0",
            borderRadius: 9,
            padding: 10,
            marginBottom: 8
          }}
        >
          <div
            style={{
              fontSize: 13,
              fontWeight: 700,
              color: "#010B36"
            }}
          >
            {ticket.contact?.name || "Cliente"}
          </div>

          <div
            style={{
              fontSize: 11,
              color: "#64748B",
              margin: "5px 0 9px"
            }}
          >
            {ticket.queue?.name || "Atendimento humano"}
          </div>

          <button
            type="button"
            disabled={busyId !== null}
            onClick={() => accept(ticket)}
            style={{
              background: "#0057FF",
              color: "#FFFFFF",
              border: 0,
              borderRadius: 7,
              padding: "9px 15px",
              fontSize: 12,
              fontWeight: 700,
              cursor: busyId !== null ? "wait" : "pointer",
              opacity: busyId !== null ? 0.6 : 1
            }}
          >
            {busyId === ticket.id
              ? "Assumindo..."
              : "Aceitar atendimento"}
          </button>
        </div>
      ))}
    </section>
  );
};

export default KoraxPendingClaims;
